import {
  Table,
  TableBody,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";
import { Checkbox } from "@/components/ui/checkbox";
import BusinessIncomeRow from "@/components/v2/molecules/admin/tabs/BusinessIncomeTab/BusinessIncomeRow";

import { type BusinessIncome } from "@/hooks/useBusinessIncome";

// Extended type for paginated business income from RPC
export interface PaginatedBusinessIncome extends Omit<BusinessIncome, 'income_type' | 'payment_type' | 'payment_status'> {
  income_type: string;
  payment_type: string;
  payment_status: string;
  organization_id: string | null;
  organization_name: string | null;
  property_short_name: string | null;
  property_title: string | null;
  total_count: number;
}

interface BusinessIncomeTableProps {
  incomes: PaginatedBusinessIncome[];
  onEdit: (income: PaginatedBusinessIncome) => void;
  onDelete: (income: PaginatedBusinessIncome) => void;
  canEdit: boolean;
  canDelete: boolean;
  selectedIncomes: string[];
  onSelectIncome: (incomeId: string, index: number, shiftKey: boolean) => void;
  onSelectAll: (checked: boolean) => void;
}

const BusinessIncomeTable = ({
  incomes,
  onEdit,
  onDelete,
  canEdit,
  canDelete,
  selectedIncomes,
  onSelectIncome,
  onSelectAll,
}: BusinessIncomeTableProps) => {
  const showActions = canEdit || canDelete;

  const tableHeaders = [
    "", // Checkbox column
    "Organización",
    "Propiedad",
    "Tipo de Ingreso",
    "Tipo de Pago",
    "Pago Bruto",
    "IVA",
    "Pago Total",
    "Descripción",
    "Estatus",
    "Fecha de Pago",
    ...(showActions ? ["Acciones"] : []),
  ];

  const allSelected = incomes.length > 0 && selectedIncomes.length === incomes.length;

  return (
    <div className="border rounded-lg">
      <Table>
        <TableHeader>
          <TableRow>
            {tableHeaders.map((header, index) => (
              <TableHead key={header || `header-${index}`}>
                {index === 0 ? (
                  <Checkbox
                    checked={allSelected}
                    onCheckedChange={onSelectAll}
                    aria-label="Seleccionar todos"
                  />
                ) : (
                  header
                )}
              </TableHead>
            ))}
          </TableRow>
        </TableHeader>

        <TableBody>
          {incomes.map((income, index) => (
            <BusinessIncomeRow
              key={income.id}
              income={income}
              index={index}
              onEdit={onEdit}
              onDelete={onDelete}
              canEdit={canEdit}
              canDelete={canDelete}
              isSelected={selectedIncomes.includes(income.id)}
              onSelect={onSelectIncome}
            />
          ))}
        </TableBody>
      </Table>
    </div>
  );
};

export default BusinessIncomeTable;
